<template>
    <div class="full-wdith-editor" v-loading="loading">
        <div class="editor-title-toolbar">
            <ReturnButton
                class="return-btn"
                @click="clickReturnBtn"
                :label="i18n.tkey('lang_return')"
            />

            <div>
                <h2 tkey="舉辦展會">{{titleName}}</h2>
            </div>

            <div class="right-operation-btn">
                <el-button
                    type="primary"
                    @click="goAddItem"
                    v-show="viewPart == 'list'"
                    tkey="添加"
                >
                    {{i18n.tkey("lang_add")}}
                </el-button>
                &nbsp;
            </div>
        </div>

        <SponsorList
            v-if="viewPart === 'list'"
            @clickEdit="goEdit"
            @clickView="goView"
            @clickGoOrder="goOrder"
        />

        <AddOrEditSponsor
            :editObj="editObj"
            :readonlyTag="readonlyTag"
            v-if="viewPart === 'edit'"
            @save-complete="clickReturnBtn"
        />
        <hallOrder
            v-if="viewPart === 'order'||viewPart === 'orderInfo'"
            :editObj="editObj"
            :viewPart="viewPart"
            @clickChangeViewPart="changeView"
        />

    </div>
</template>

<script setup>

import AddOrEditSponsor from "@/components/shopopee/hall/addOrEditSponsor.vue";
import SponsorList from "@/components/shopopee/hall/sponsorList.vue";
import ReturnButton from "@/components/shopopee/common/returnButton.vue";
import {inject, ref, computed, onBeforeMount} from "vue";
import record14Api from "@/request/record14Api";
import myUtil from "@/util/util";
import HallOrder from "@/components/shopopee/hall/hallOrder.vue";

const i18n = inject("i18n")

const props = defineProps(["showReturnBtn"])
const emits = defineEmits(["clickReturnBtn"])
const titleName = ref(i18n.tkey('lang_Organize_exhibitions'))


const viewPart = ref("list")
const editObj = ref(null)
const readonlyTag = ref(false)
const authObj = ref({})
const loading = ref(false)

const shopCompany = ref({})

const { getAuthObj } = inject('hallManagerFunc', { getAuthObj: () => {} })
const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return {} } })

function goAddItem(){

    countNum((value) => {
        if (value < authObj.value.hallNum){
            viewPart.value = "edit"
        }else{
            myUtil.alertWarning(i18n.tkey("lang_open_hall_alert"))
        }
    })


}
function changeView(mviewPart){
  viewPart.value = mviewPart
}
function clickReturnBtn(){
    if (viewPart.value === "edit"){
        viewPart.value = "list"
        editObj.value = null
    }else if (viewPart.value === "order"){
      viewPart.value = "list"
      editObj.value = null
      titleName.value = i18n.tkey('lang_Organize_exhibitions')
    }else if (viewPart.value === "orderInfo"){
      viewPart.value = "order"
      editObj.value = null
    }
    else{
        emits("clickReturnBtn", "returnHome")
    }

}

function goEdit(obj){
    readonlyTag.value = false
    editObj.value = obj
    viewPart.value = "edit"

    titleName.value = i18n.tkey('lang_Organize_exhibitions')
}

function goView(obj){
    readonlyTag.value = true
    editObj.value = obj
    viewPart.value = "edit"
    titleName.value = i18n.tkey('lang_Organize_exhibitions')
}
function goOrder(obj){

  editObj.value = obj
  viewPart.value = "order"
  titleName.value = i18n.tkey('lang_custom_order')
}


function countNum(callback){
    loading.value = true

    const request = record14Api.countAdditionalrecord14
    const params = request.getParams()

    params.companycode = shopCompany.value.companycode

    request.send(params, (res) => {
        loading.value = false
        if (res.code == 200){
            if (typeof callback === "function"){
                callback(res.detail)
            }
        }
    })

}

onBeforeMount(() => {
    shopCompany.value = getShopCompanyObj()
    authObj.value = getAuthObj()
})

</script>

<style scoped>
.full-wdith-editor {
    width: 100%;
}

.editor-title-toolbar {
    text-align: center;
    position: relative;
    margin-bottom: 32px;
}

.editor-title-toolbar .return-btn {
    position: absolute;
    left: 0;
    top: 5px;
}

.editor-title-toolbar .right-operation-btn {
    position: absolute;
    right: 0;
    top: 0;
}

</style>